import { router } from '@inertiajs/react';
import { Search } from 'lucide-react';
import { useRef, useState } from 'react';
import { Input } from '@/components/ui/input';

interface SponsorCreditsSearchProps {
  eventSlug: string;
  sponsorSlug: string;
  search: string;
}

export function SponsorCreditsSearch({
  eventSlug,
  sponsorSlug,
  search,
}: SponsorCreditsSearchProps) {
  const [value, setValue] = useState(search);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  function handleChange(newValue: string) {
    setValue(newValue);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const params = newValue.trim() ? { q: newValue.trim() } : {};
      router.get(`/admin/${eventSlug}/sponsors/${sponsorSlug}`, params, {
        replace: true,
        preserveState: true,
        preserveScroll: true,
      });
    }, 300);
  }

  return (
    <div className="relative">
      <Search className="-translate-y-1/2 absolute top-1/2 left-3 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search by hacker name, email, notes or URL..."
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}
